import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdBusinessOwnersOptions } from '@onefootprint/fetch-dashboard';
import type { Entity } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import ErrorComponent from '@/components/error';
import Forbidden, { isForbiddenError } from '@/components/forbidden';
import Content from './components/content';
import Loading from './components/loading';
export type BusinessOwnersProps = {
  entity: Entity;
};
const BusinessOwners = t0 => {
  const $ = _c(10);
  const {
    entity
  } = t0;
  let t1;
  if ($[0] !== entity.id) {
    t1 = getEntitiesByFpIdBusinessOwnersOptions({
      path: {
        fpId: entity.id
      }
    });
    $[0] = entity.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isPending,
    error,
    data
  } = useQuery(t1);
  let t2;
  if ($[2] !== entity.data) {
    t2 = entity.data.find(_temp)?.value?.toString();
    $[2] = entity.data;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const explanationMessage = t2;
  if (isPending) {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Loading />;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  if (error) {
    let t3;
    if ($[5] !== error) {
      t3 = isForbiddenError(error) ? <Forbidden /> : <ErrorComponent error={error} />;
      $[5] = error;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  if (data) {
    let t3;
    if ($[7] !== data || $[8] !== explanationMessage) {
      t3 = <Content businessOwners={data} explanationMessage={explanationMessage} />;
      $[7] = data;
      $[8] = explanationMessage;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  return null;
};
export default BusinessOwners;
function _temp(item) {
  return item.identifier === "business.beneficial_owner_explanation_message";
}